import { render, staticRenderFns } from "./Liquibase.vue?vue&type=template&id=b7dadeac&"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b7dadeac')) {
      api.createRecord('b7dadeac', component.options)
    } else {
      api.reload('b7dadeac', component.options)
    }
    module.hot.accept("./Liquibase.vue?vue&type=template&id=b7dadeac&", function () {
      api.rerender('b7dadeac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/icons/partnerIcons/Liquibase.vue"
export default component.exports